import { Paper as PaperType } from "../../types/Paper";
import PaperKeywords from "../PaperKeywords/PaperKeywords";
import PaperParameters from "../PaperParameters/PaperParameters";

type PaperKeywordsProps = {
  paper: PaperType;
  repositoryId: string;
  addKeywordToPaper?: (
    repoId: string,
    paperId: string,
    keyword: string
  ) => Promise<void>;
  removeKeywordFromPaper?: (
    repoId: string,
    paperId: string,
    keywordId: string
  ) => Promise<void>;
  addParameterToPaper?: (
    repoId: string,
    paperId: string,
    parameter: string
  ) => Promise<void>;
  removeParameterFromPaper?: (
    repoId: string,
    paperId: string,
    parameterId: string
  ) => Promise<void>;
};

const Paper = (props: PaperKeywordsProps) => {
  return (
    <div className="tab-content" id="myTabContent">
      <div
        className="tab-pane fade show active"
        id="home"
        role="tabpanel"
        aria-labelledby="home-tab"
      >
        <div className="row mb-3">
          <div className="col-md-10">
            <span className="title-top">Title</span>
            <h5 className="title-main">
              {props.paper ? props.paper.name : "No Paper selected"}
            </h5>
          </div>
          <div className="col-md-2 text-right">
            <span className="title-top text-right">Date</span>
            <h5 className="title-main date text-right">
              {props.paper ? props.paper.created_at : "No Paper selected"}
            </h5>
          </div>
        </div>
        <PaperKeywords
          keywords={props.paper.keywords ? props.paper.keywords : []}
          addKeywordToPaper={props.addKeywordToPaper}
          removeKeywordFromPaper={props.removeKeywordFromPaper}
          repoId={props.repositoryId ?? ""}
          paperId={props.paper?.id ?? ""}
        />
        <PaperParameters
          parameters={props.paper.parameters ? props.paper.parameters : []}
          addParameterToPaper={props.addParameterToPaper}
          removeParameterFromPaper={props.removeParameterFromPaper}
          repoId={props.repositoryId ?? ""}
          paperId={props.paper?.id ?? ""}
        />
        {/* <RepositoryMethodology /> */}
      </div>
    </div>
  );
};

export default Paper;
